import { render, staticRenderFns } from "./product_10_ckw.vue?vue&type=template&id=39a2a77b&scoped=true"
import script from "./product_10_ckw.vue?vue&type=script&lang=js"
export * from "./product_10_ckw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a2a77b",
  null
  
)

export default component.exports